import { Button } from "@dmca/frontend/components/button";
import { Input } from "@dmca/frontend/components/input";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "react-toastify";

export const Route = createFileRoute(
  "/_authed/_drawerLayout/admin/machinery/machines/add-new"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { trpcQcProxy: trpc, qc } = Route.useRouteContext();
  const navigate = Route.useNavigate();

  const { data: plants } = useQuery(trpc.plant.getAll.queryOptions());

  const [name, setName] = useState("");
  const [plantId, setPlantId] = useState("");
  const [type, setType] = useState<"forklift" | "crane" | null>(null);
  const [isDirty, setIsDirty] = useState(false);

  const mutation = useMutation(
    trpc.machinery.add.mutationOptions({
      onSuccess: (data) => {
        qc.setQueryData(trpc.machinery.getAll.queryKey(), (old) => {
          if (!old) return [data];
          return [...old, data];
        });
        navigate({
          to: "/admin/machinery/machines/$id",
          params: { id: data.id },
        });
      },
      onError: () => {
        toast.error("An error occurred. Please try again or contact support.");
      },
    })
  );

  const isValid = name.trim() && plantId && type;

  return (
    <Stack spacing={2} sx={{ mt: 1 }} component="form">
      <Input
        label="Machine Name"
        required
        value={name}
        onChange={(e) => {
          setIsDirty(true);
          setName(e.target.value);
        }}
        error={isDirty && !name.trim()}
        errorText="Machine name is required."
      />
      <FormControl fullWidth size="small" required data-testid="machinery-plant-select">
        <InputLabel>Plant</InputLabel>
        <Select
          value={plantId}
          label="Plant"
          onChange={(e) => setPlantId(e.target.value)}
        >
          {plants?.map((p) => (
            <MenuItem key={p.id} value={p.id}>
              {p.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Stack spacing={1}>
        <Typography variant="body2" color="text.secondary">
          Type *
        </Typography>
        <ToggleButtonGroup
          value={type}
          exclusive
          onChange={(_, val) => val && setType(val)}
          size="small"
          fullWidth
        >
          <ToggleButton value="forklift">Forklift</ToggleButton>
          <ToggleButton value="crane">Crane</ToggleButton>
        </ToggleButtonGroup>
      </Stack>
      <Button
        fullWidth
        disabled={!isValid}
        loading={mutation.isPending}
        type="submit"
        onClick={(e) => {
          e.preventDefault();
          if (!type) return;
          mutation.mutate({ name: name.trim(), plantId, type });
        }}
      >
        Add Machine
      </Button>
    </Stack>
  );
}
